<template>
  <div>
    <v-text-field
      label="Nome"
      v-model="fields.name.value"
      :rules="fields.name.rules"
      type="text"
      outlined dense
    ></v-text-field>
    <v-text-field
      label="Código"
      v-model="fields.code.value"
      :rules="fields.code.rules"
      type="text"
      outlined dense
    ></v-text-field>
    <v-autocomplete
      v-model="fields.step.value"
      :items="fields.step.options"
      label="Etapa"
      chips small-chips multiple
      outlined dense
    ></v-autocomplete>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'userForm',
  data: () => ({
    fields: {
      name: {
        value: '',
        rules: []
      },
      code: {
        value: '',
        rules: []
      },
      step: {
        value: '',
        options: [
          { value: 'active', text: 'Ativa' },
          { value: 'inactive', text: 'Desabilitada' },
          { value: 'incomplete', text: 'Incompleta' },
          { value: 'ended', text: 'Finalizada' }
        ],
        rules: []
      }
    }
  }),
  computed: {
    ...mapGetters(['searchParams']),
    formParams () {
      return this.searchParams('celebrations')
    }
  },
  watch: {
    fields: {
      handler (val) {
        this.$emit('datachange', this.fields)
      },
      deep: true
    },
    formParams: {
      handler (val) {
        for (let key in val) {
          if (this.fields[key] && this.fields[key] !== val[key]) this.fields[key].value = val[key]
        }
      },
      deep: true
    }
  },
  mounted () {
    for (let key in this.searchParams('celebrations')) {
      if (this.fields[key] && this.fields[key] !== this.searchParams('celebrations')[key]) this.fields[key].value = this.searchParams('celebrations')[key]
    }
  }
}
</script>
